const mapBackOrderDate = require('./backOrderDate');

/**
 * childSKU maps a product variant. Used mainly in subscription.
 *
 * @param {import('.').KitSKUQuantity[]} kits
 * @param {import('.').EquinoxNormalProduct} product
 */
function childSKUBundle(kits, product) {
  const sku = product.sku.filter(sku => sku.default)[0];

  if (!sku) {
    throw Error('Unable to find the default SKU for product ' + product.identifier);
  }

  const kit = kits.filter(k => k.sku === product.identifier)[0];
  if (!kit) {
    throw Error('Product in bundle does not exist in the list of available variants.');
  }

  return {
    productId: product.identifier,
    skuId: sku.identifier,
    type: 'MANDATORY',
    skuQuantity: kit.qty,
    availableChannels: sku.properties.availableChannels,
    inventory: {
      atpQty: sku.inventoryProperties.atpQty,
      backOrdered: sku.inventoryProperties.backOrdered,
      backOrderDate: mapBackOrderDate(sku)
    }
  }
}


module.exports = childSKUBundle;
